import { useState } from "react"

const getStoredResults = () => {
  try {
    return JSON.parse(window.localStorage.getItem("recentlyViewed")) || []
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(
      `Could not fetch recently viewed results from localStorage. Error: ${error}`
    )
    return []
  }
}

const setStoredResults = (setViewedResults, result) => {
  const oldResults = getStoredResults()

  const newResults = [
    result,
    ...oldResults.filter(oldResult => oldResult.slug !== result.slug)
  ].slice(0, 5)

  try {
    window.localStorage.setItem("recentlyViewed", JSON.stringify(newResults))
    setViewedResults(newResults)
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(`Could not set result in localStorage. Error: ${error}`)
  }
}

export default () => {
  const [viewedResults, setViewedResults] = useState(() => getStoredResults())
  return [viewedResults, result => setStoredResults(setViewedResults, result)]
}
